export { default } from "./useThemeWithoutDefault.js";